// src/features/editor/components/studio/useBlockIndex.ts
import { skipToken } from '@reduxjs/toolkit/query/react'
import { useGetLessonBlocksQuery } from '@/features/editor/lessonsApi'
import { useAppSelector } from '@/store/hooks'

/**
 * Позиционный ранг блока в списке урока (0-based, тот же плотный счёт, что
 * видит миниатюра — `BlockThumbnail`'s `index`) — НЕ `block.order`: удаление
 * соседнего блока не перенумеровывает `order` (только реордер это делает),
 * поэтому `order` идёт с дырами, а текст подтверждения удаления обязан
 * называть настоящую позицию (ревью Task 2, Important-1: шапка панели
 * называла `order + 1` и расходилась с миниатюрой на том же блоке).
 */
export const useBlockIndex = (blockId: number | null): number | null => {
  const selectedLessonId = useAppSelector((s) => s.editor.selectedLessonId)
  const { data: blocks = [] } = useGetLessonBlocksQuery(selectedLessonId ?? skipToken)
  if (blockId === null) return null
  const index = blocks.findIndex((b) => b.id === blockId)
  return index === -1 ? null : index
}
